import { createAction } from "@coverme/redux";
import Axios from "axios";

export const getTest = () =>
    createAction("GET_TEST", () =>
        Axios.get("/api/retrocheck/test").then(data => {
            data.data;
        })
    );

export const getFiles = (customerId, query, cancellationToken) => {
    const config = cancellationToken != null ? { cancelToken: cancellationToken } : {};
    return createAction("GET_RETROCHECKBILLING_FILES", () =>
        Axios.post(`/api/retrocheckbilling/files`, query || {}, config).then(res => res.data)
    );
};

export function updateFileFilter(filter, query) {
    return {
        type: "UPDATE_RETROCHECKBILLING_FILTER",
        filter: filter,
        query: query,
    };
}
